import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";

import { OpProofcardService } from "src/app/views/common/services/op-proofcard.service";
import * as FileSaver from "file-saver";

@Component({
  selector: "app-proofcard-download-poup",
  templateUrl: "./proofcard-download-poup.component.html",
  styleUrls: ["./proofcard-download-poup.component.css"],
})
export class ProofcardDownloadPoupComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() addressData: any;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  posterURL = environment.posterURL;
  codeList: any = [];
  tosterConfig = {
    positionClass: "toast-top-center",
  };
  jobId: null;
  download: any = [];
  proofcards_number: any;
  page = { count: 0, pageSize: 0, limit: 10, offset: 0 };

  searchNFilterSetting = {
    isSearchActive: false,
    isFilterActive: false,
    FilterValue: null,
    FilterColumn: null,
    FilterItem: null,
  };
  exportName: any = "";
  userRolesNPermission: any;
  isDownloading: any = [];

  constructor(
    private activeModal: NgbActiveModal,
    private opProofcardServ: OpProofcardService
  ) {}

  public dismiss() {
    this.activeModal.dismiss();
  }

  getSiteList() {
    this.opProofcardServ.getAllQrcodeshistory().subscribe(
      (res: any) => {
        this.download = res.data;
      },
      (err: any) => {
        console.error(err);
      }
    );
    console.log("data ", this.download);
  }

  getAllQrcodeshistoryjobId() {
    this.opProofcardServ
      .getAllQrcodeshistoryjobId(this.addressData.job_id)

      .subscribe((res: any) => {
        console.log("res : ", res.data);
        this.download = res.data;

        for (let index = 0; index < this.download.length; index++) {
          this.isDownloading.push(false);
        }
      });

    console.log("getAllPDF ", this.addressData);
  }

  ngOnInit() {
    // this.showdata()
    this.getAllQrcodeshistoryjobId();
  }

  Download(qrData, index) {
    const proofcardNumbers = qrData.proofcards_number.split(",");
    let exportName =
      proofcardNumbers[0] +
      ".." +
      proofcardNumbers[proofcardNumbers.length - 1];
    try {
      this.isDownloading[index] = true;
      this.opProofcardServ.DownloadQrCodeAll(qrData.id).subscribe(
      // this.opProofcardServ.DownloadProofcardAll(qrData.id).subscribe(
        (res) => {
          this.isDownloading[index] = false;
          // console.log('qrcodedata: ', res);
          const blob = new Blob([res], {
            type: "application/pdf",
          });
          // console.log("addressData", this.addressData);

          FileSaver.saveAs(blob, "qrcode.pdf");
          // FileSaver.saveAs(blob, exportName + ".pdf");
        },
        (error) => {
          this.isDownloading[index] = false;
        }
      );
    } catch (error) {
      this.isDownloading[index] = false;
    }
  }
}
